import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from "../config";
import '../css/personalInfoForm.css';

const PersonalInfoForm = ({ onNext }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email_address: '',
    phone_number: '',
    country: '',
    state: '',
    city: '',
    address1: '',
    address2: '',
    zip_code: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/personal-info`, formData, { withCredentials: true });
      onNext();
    } catch (err) {
      console.error('Error submitting personal info:', err);
    }
  };

  return (
    <div>
      <div className="upload-section">
        <div className="upload-box">
          <div className="upload-input"></div>
        </div>
      </div>

      <form className="info-grid" onSubmit={handleSubmit} autoComplete="off">
        <input name="first_name" type="text" placeholder="First name" onChange={handleChange} required />
        <input name="last_name" type="text" placeholder="Last name" onChange={handleChange} required />
        <input name="email_address" type="email" placeholder="Email address" onChange={handleChange} required />
        <input name="phone_number" type="text" placeholder="Phone number" onChange={handleChange} required />
        <input name="country" type="text" placeholder="Country" onChange={handleChange} required />
        <input name="state" type="text" placeholder="State" onChange={handleChange} required />
        <input name="city" type="text" placeholder="City" onChange={handleChange} required />
        <input name="address1" type="text" placeholder="Address 1" onChange={handleChange} required />
        <input name="address2" type="text" placeholder="Address 2" onChange={handleChange} />
        <input name="zip_code" type="text" placeholder="Zip code" onChange={handleChange} pattern="(\d{5,6}|[A-Z]{2}\s\d{5})" title="Enter ZIP code" required />

        <button className="next">Next</button>
      </form>
    </div>
  );
};

export default PersonalInfoForm;
